import { render, staticRenderFns } from "./ResourceFormComponent.vue?vue&type=template&id=1cb4f853"
import script from "./ResourceFormComponent.vue?vue&type=script&lang=js"
export * from "./ResourceFormComponent.vue?vue&type=script&lang=js"
import style0 from "./ResourceFormComponent.vue?vue&type=style&index=0&id=1cb4f853&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports